import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const USER_ENDPOINTS = {
  list: `${BASE_URL}api/users/`,
  register: `${BASE_URL}auth/register`,
  me: `${BASE_URL}api/users/me`,
  // me: `https://as-datahub-bk-p-weur-001.azurewebsites.net/'users/me`,

  detail: (id) => `${BASE_URL}users/${id}`,
  roles: `${BASE_URL}api/roles/`,
  login_verification: `${BASE_URL}api/users/login_verification`,
  verify_code: `${BASE_URL}api/users/verify_code`,
};

class Users {
  async getActiveUserInfo() {
    const { data } = await request({
      url: USER_ENDPOINTS.me,
    });
    return data;
  }

  async getUser(id) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
    });
    return data;
  }

  async createUser(userData) {
    const { data } = await request({
      url: USER_ENDPOINTS.register,
      method: "POST",
      body: userData,
    });
    return data;
  }

  async editUser(id, userData) {
    const { data } = await request({
      url: USER_ENDPOINTS.detail(id),
      method: "PATCH",
      body: userData,
    });
    return data;
  }

  async deleteUser(id) {
    return await request({
      url: USER_ENDPOINTS.detail(id),
      method: "DELETE",
    });
  }

  async getRoles() {
    const { data } = await request({
      url: USER_ENDPOINTS.roles,
    });
    return { data };
  }

  async login_verification(userData) {
    const { data, res } = await request({
      url: USER_ENDPOINTS.login_verification,
      method: "POST",
      body: userData,
    });
    return { data, res };
  }

  // async login_verification(userData) {
  //   try {
  //     await request({
  //       url: "https://datahubupload.forvismazars.com/api/users/login_verification",
  //       method: "POST",
  //       body: userData,
  //     });

  //     const { data } = await request({
  //       url: USER_ENDPOINTS.login_verification,
  //       method: "POST",
  //       body: userData,
  //     });

  //     return { data };
  //   } catch (error) {
  //     debugger;
  //     console.error("An error occurred during login verification:", error);
  //   }
  // }

  async verify_code(userData) {
    const { data, res } = await request({
      url: USER_ENDPOINTS.verify_code,
      method: "POST",
      body: userData,
    });

    return { data, res };
  }
}

export const UsersService = new Users();
